module.exports = __webpack_public_path__ + "img/86014093.01c84efd.png";